import { ModuleHeader } from '../module-header'
import TeacherExamsItem from './teacher-exam-list-item'
import { AvailableExamsGrid } from './teacher-exam-list.style'

const TeacherExamList = ({ isAssignment }) => {
    //Simulate an array
    const itemList = [1, 2]
    return (
        <>
            <ModuleHeader title={!isAssignment ? "Exams" : "ASSIGNMENTS"} />
            <AvailableExamsGrid>
                {itemList.map(item => (
                    <TeacherExamsItem key={item} isAssignment={isAssignment} />
                ))}
            </AvailableExamsGrid>
        </>
    )
}

export { TeacherExamList }
